import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = ["title", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_footer_container = _resolveComponent("footer-container")!

  return (_openBlock(), _createBlock(_component_footer_container, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
          return (_openBlock(), _createElementBlock("a", {
            class: _normalizeClass(["col", { active: _ctx.isActive(item) }]),
            key: item.name,
            title: item.text,
            onClick: _withModifiers(($event: any) => (_ctx.onMenuClick(item)), ["prevent"])
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(item.icon)
            }, null, 2),
            _createElementVNode("span", null, _toDisplayString(item.text), 1)
          ], 10, _hoisted_2))
        }), 128))
      ])
    ]),
    _: 1
  }))
}